import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PagedList } from '../models/paged-list.interface';
import { AssignmentReportCreate } from '../models/project/assignment/report/assignment-report-create.interface';
import { AssignmentReport } from '../models/project/assignment/report/assignment-report.interface';
import { RequestModel } from '../models/request-model.interface';
import { ReportType } from '../models/report-type/report-type.interface';

@Injectable()
export class AssignmentReportService {
  private readonly httpClient = inject(HttpClient);


  public getAssignmentReportTypes(assignmentId: string): Observable<ReportType[]> {
    return this.httpClient
      .get<ReportType[]>(`${environment.apiUrl}/assignments/${assignmentId}/reports/report-types`)
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public getAssignmentReports(assignmentId: string): Observable<AssignmentReport[]> {
    return this.httpClient
      .get<AssignmentReport[]>(`${environment.apiUrl}/assignments/${assignmentId}/reports`)
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public getAssignmentReportsPaged(
    assignmentId: string,
    request: RequestModel,
  ): Observable<PagedList<AssignmentReport>> {
    return this.httpClient
      .post<PagedList<AssignmentReport>>(`${environment.apiUrl}/assignments/${assignmentId}/reports/paged`, request)
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public createAssignmentReport(
    assignmentId: string,
    model: AssignmentReportCreate,
    correlationId?: string,
  ): Observable<AssignmentReport> {
    return this.httpClient
      .post<AssignmentReport>(`${environment.apiUrl}/assignments/${assignmentId}/reports`, model, {
        headers: this.buildHeaders(correlationId),
      })
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public updateAssignmentReport(
    assignmentId: string,
    reportId: string,
    model: AssignmentReportCreate,
    correlationId?: string,
  ): Observable<AssignmentReport> {
    return this.httpClient
      .put<AssignmentReport>(`${environment.apiUrl}/assignments/${assignmentId}/reports/${reportId}`, model, {
        headers: this.buildHeaders(correlationId),
      })
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public deleteAssignmentReport(assignmentId: string, reportId: string): Observable<null> {
    return this.httpClient
      .delete<null>(`${environment.apiUrl}/assignments/${assignmentId}/reports/${reportId}`)
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  private buildHeaders(correlationId?: string): HttpHeaders | undefined {
    if (!correlationId) {
      return undefined;
    }

    return new HttpHeaders({
      'X-Correlation-Id': correlationId,
    });
  }
}
